export default "__VITE_ASSET__C3OrMWKR__"